export enum SubscriptionType {
  Yearly = 'yearly',
  Monthly = 'monthly',
  Pro = 'pro',
}
